export default __webpack_public_path__ + "static/media/message_blue.3065b5d0.svg";